import {ADD_TO_HOME_SCREEN_FROM_SETTINGS, PWA_INSTALL_AVAILABLE, PWA_INSTALLED} from "../constants/pwa.constants";
import {ADD_TO_HOME_SCREEN_POPUP} from "../components/popups/add-to-home-screen/AddToHomeScreen";

export const addToHomeScreenFromSettings = () => ({
	type: ADD_TO_HOME_SCREEN_FROM_SETTINGS
})

export const pwaInstallAvailable = () => ({
	type: PWA_INSTALL_AVAILABLE
})
export const pwaInstalled = () => ({
	type: PWA_INSTALLED,
	hidePopups: [ADD_TO_HOME_SCREEN_POPUP]
})
